import * as yup from "yup";
import React from "react";
import i18n, { useTranslation } from "utilities/i18n";
import { useUpdateTeamsWebhookMutation } from "generated/graphql";
import { AutoSave, Form, Formik, Input } from "collections";
import { SubForms } from "./SubForms";
import { ChangeSaveNotification } from "../../ServiceNow/Edit/ChangeSaveNotification";
import { InferType } from "yup";

export const NameToggleFormSchema = yup.object({
  name: yup
    .string()
    .label(i18n.t("NAME"))
    .required(),
  url: yup
    .string()
    .label(i18n.t("URL"))
    .required()
});
export type EditType = InferType<typeof NameToggleFormSchema>;

export const NameForm: React.FC<SubForms> = ({
  webHooksId,
  ac: { name, url },
  hooks
}) => {
  const { t } = useTranslation();
  const [, updateHook] = useUpdateTeamsWebhookMutation();

  const checkDuplicates = (values: EditType) => {
    let errors: any = {};
    const foundHook = hooks?.find(
      x =>
        x.name.toUpperCase() === values.name.toUpperCase() &&
        x.id !== webHooksId
    );

    if (foundHook) {
      errors["name"] = t("ERROR_DUPLICATE_INTEGRATION_HOOK", {
        hookName: values?.name
      });
    }

    return errors;
  };

  return (
    <Formik<EditType>
      key={webHooksId}
      name="TeamsUrlForm"
      validationSchema={NameToggleFormSchema}
      initialValues={{ url, name }}
      validate={checkDuplicates}
      onSubmit={async (values, helpers) => {
        await updateHook({
          id: webHooksId,
          input: {
            name: values.name,
            url: values.url
          }
        });
      }}
    >
      {({ isValid, field: { name, url } }) => (
        <Form className="form grid" data-testid="name-form">
          <ChangeSaveNotification />
          <AutoSave debounceMs={500} />
          <div className="mt-15 ph-2">
            <label>{t("NOTIFICATION_TEAMS_EDIT")}</label>
          </div>
          <div
            className={`form-group${isValid ? " error-message-spacing" : ""}`}
          >
            <label className="col-3 text-right" htmlFor={name.name}>
              {name.label}:
            </label>
            <div className="col-5">
              <Input {...name} label={undefined} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-3 text-right" htmlFor={url.name}>
              {url.label}:
            </label>
            <div className="col-5">
              <Input {...url} label={undefined} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
